<template>
  <div>
    <div v-if="!!master.desc" class="guide mb-3 body-2">
      <pre>{{master.desc}}</pre>
    </div>
    <v-radio-group
      class="book-option-radio-group"
      hide-details="false"
      :value="value" @change="onChange"
    >
      <v-radio
        v-for="item in items"
        :key="item.id"
        :value="item.id"
      >
        <template #label>
          <div class="name">{{item.name}}</div>
          <div v-if="item.price > 0" class="price">
            <em>{{item.price | comma}}</em>
            <small>円</small>
          </div>
          <div v-else-if="item.id !== 0" class="price">
            <em>無料</em>
          </div>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.book-option-radio-group {
  padding: 11px;
  border: 1px solid $divider-color;

  .v-label.theme--light {
    color: $title-black-text-color;
  }

  .name {
    flex: 1;
  }

  .price {
    > em {
      font-weight: normal;
      font-style: normal;
    }

    > small {
      margin-left: 0.5em;
      font-weight: normal;
    }
  }
}
</style>

<script>
import PartBase from '@/mixins/PartBase'

export default {
  name: 'OptDeli',
  mixins: [
    PartBase
  ],
  props: {
    master: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  computed: {
    items () {
      return [
        { id: 0, name: 'なし', price: 0 },
        { id: 1, name: '出発のみ', price: this.master.oneway },
        { id: 2, name: '帰着のみ', price: this.master.oneway },
        { id: 3, name: '往復', price: this.master.round }
      ]
    }
  },
  methods: {
    onChange (value) {
      this.$emit('change', value)
    }
  }
}
</script>
